// extracted by mini-css-extract-plugin
module.exports = {"container":"SubscriberRejectPage_container__oChoY"};